import React, { useState } from "react";
import "./styles.css";
import { Button, Collapse } from "react-bootstrap";

const TimelineHistory = ({ history }) => {
  const [open, setOpen] = useState(false);

  const listItems = () => {
    return history.map((item, index) => {
      //console.log("historial: ", history);
      return itemHistory(
        item?.hour,
        item?.status,
        item?.level,
        item?.change,
        index
      );
    });
  };

  function getDescriptionbyStatus(status) {
    const txt = {
      ENVIADA: "Enviada",
      LISTO: "Espera de repartidor",
      "EN TRANSITO": "Va a la tienda",
      "LLEGUE-P-R": "Repartidor en tienda",
      "EN CAMINO": "Va con el cliente",
      "LLEGUE-P-C": "Repartidor en domicilio",
      FINALIZADO: "Orden finalizada",
      DENIED: "Rechazada por repartidor",
      "ORDER ACCEPTED": "Aceptada por el repartidor",
      "ASSIGMENT IN SERVICE DESKTOP": "Asignada",
    };
    return txt[status] || "Desconocido ):";
  }

  function colorItemTimeline(level, status) {
    if (status === "DENIED") {
      return "event-date bg-soft-danger text-danger";
    } else {
      const txt = {
        NUEVA: "event-date bg-soft-primary text-primary",
        "EN PROCESO": "event-date bg-soft-warning text-dark",
        "EN TRANSITO": "event-date bg-soft-success text-success",
        FINALIZADO: "event-date bg-soft-primary text-primary",
      };
      return txt[level] || "event-date bg-soft-primary text-primary";
    }
  }

  const itemHistory = (hour, status, level, change, key) => {
    let correctHour = hour.substring(11, 16);
    let correctDay = hour.substring(0, 10);
    return (
      <li key={key} className="list-inline-item event-list">
        <div>
          <div className={colorItemTimeline(level, status)}>{correctHour}</div>
          <div>
            <p className="text-muted text-center">
              {getDescriptionbyStatus(change ?? status)}
            </p>
            <p className="text-muted">{correctDay}</p>
          </div>
        </div>
      </li>
    );
  };

  return (
    <div>
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        variant="light"
      >
        {open ? "Historial" : "Ver el historial"}
      </Button>
      <Collapse in={open}>
        <div className="scrollmenu">
          <div className="container">
            <div className="card-body">
              <div className="hori-timeline" dir="ltr">
                <div
                  style={{
                    width: "90%",
                    height: 3,
                    //top: "16%",
                    zIndex: 0,
                    backgroundColor: "#e9ecef",
                    position: "absolute",
                  }}
                />
                <ul className="list-inline events">{listItems()}</ul>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default TimelineHistory;
